import { getCollages, saveCollage, deleteCollage } from "api";
import confirm from "components/Dialog";
import t from "translations";

const collages = store => {
  store.on("@init", () => ({ collages: [], isCollagesLoading: false }));
  store.on("collage/set", (_, collages) => ({
    collages: [...collages],
    isCollagesLoading: false
  }));
  store.on("collage/setLoading", (_, isCollagesLoading) => ({
    isCollagesLoading
  }));

  store.on("collage/select", async (state, collage) => {
    const { isAdmin, canvas } = state;
    const { id, canvasData } = collage;
    const { dispatch } = store;
    if (!isAdmin) {
      if (canvas.DPE.persistent.isCanvasEmpty()) {
        if (canvasData) {
          canvas.DPE.persistent.loadFromBase64(canvasData);
          canvas.DPE.collage.disableEdit();
          dispatch("collage/setId");
          return;
        }
      }
      const result = await confirm.show({
        text: t.newCanvasWarn,
        title: t.newCanvasWarnTitle
      });
      if (!result) {
        return;
      }
      if (canvasData) {
        canvas.DPE.persistent.loadFromBase64(canvasData);
        canvas.DPE.collage.disableEdit();
        dispatch("collage/setId");
        return;
      }
    }
    else {
      if (canvasData) {
        canvas.DPE.persistent.loadFromBase64(canvasData);
        dispatch("collage/setId", id);
      }
    }
  });

  store.on("collage/setId", (_, id) => {
    if (id !== undefined) {
      return { id, editorType: "collage" };
    }
    return { editorType: "collage" };
  });

  store.on("collage/get", async () => {
    try {
      store.dispatch("collage/setLoading", true);
      const collages = await getCollages();
      store.dispatch("collage/set", collages);
    } catch (err) {
      store.dispatch("notification/error", err.message);
      store.dispatch("collage/setLoading", false);
    }
  });

  store.on("collage/create", async () => {
    try {
      store.dispatch("collage/setLoading", true);
      const id = await saveCollage(null, "Unnamed collage", null);
      store.dispatch("collage/get");
      store.dispatch("notification/success", `Collage ID:${id} created!`);
    } catch (err) {
      store.dispatch("notification/error", err.message);
      store.dispatch("collage/setLoading", false);
    }
  });

  store.on("collage/save", async (state, title) => {
    if (!state.id || !state.canvas) {
      return;
    }
    const { id, canvas } = state;
    const canvasData = canvas.DPE.persistent.toBase64();
    try {
      store.dispatch("collage/setLoading", true);
      const responseId = await saveCollage(id, title, canvasData);
      store.dispatch("collage/get");
      store.dispatch(
        "notification/success",
        `Collage ${title} ID:${responseId} saved!`
      );
    } catch (err) {
      store.dispatch("notification/error", err.message);
      store.dispatch("collage/setLoading", false);
    }
  });

  store.on("collage/delete", async (_, id) => {
    try {
      store.dispatch("collage/setLoading", true);
      await deleteCollage(id);
      store.dispatch("collage/get");
      store.dispatch("notification/success", `Collage ID:${id} removed!`);
    } catch (err) {
      store.dispatch("notification/error", err.message);
      store.dispatch("collage/setLoading", false);
    }
  });
};


export default collages;
